function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.692 1c.51 0 .923.403.923.9h0v8.228c1.628.404 2.768 1.834 2.768 3.472s-1.14 3.068-2.768 3.472h0V18.1c0 .497-.413.9-.923.9a.912.912 0 01-.923-.9h0v-1.028C2.14 16.668 1 15.238 1 13.6s1.14-3.068 2.769-3.472h0V1.9c0-.497.413-.9.923-.9zm16.616 0c.51 0 .923.403.923.9h0v8.228C23.86 10.532 25 11.962 25 13.6s-1.14 3.068-2.769 3.472h0V18.1c0 .497-.413.9-.923.9a.912.912 0 01-.923-.9h0v-1.028c-1.628-.404-2.768-1.834-2.768-3.472s1.14-3.068 2.768-3.472h0V1.9c0-.497.413-.9.923-.9zM13 1c.51 0 .923.403.923.9h0v1.028c1.629.404 2.769 1.834 2.769 3.472s-1.14 3.068-2.769 3.472h0V18.1c0 .497-.413.9-.923.9a.912.912 0 01-.923-.9h0V9.872C10.448 9.468 9.308 8.038 9.308 6.4s1.14-3.068 2.769-3.472h0V1.9c0-.497.413-.9.923-.9zM4.692 11.8c-1.02 0-1.847.806-1.847 1.8s.827 1.8 1.847 1.8 1.846-.806 1.846-1.8-.827-1.8-1.846-1.8zm16.616 0c-1.02 0-1.846.806-1.846 1.8s.827 1.8 1.846 1.8c1.02 0 1.847-.806 1.847-1.8s-.827-1.8-1.847-1.8zM13 4.6c-1.02 0-1.846.806-1.846 1.8S11.98 8.2 13 8.2s1.846-.806 1.846-1.8S14.02 4.6 13 4.6z",
  fill: "#333",
  fillRule: "nonzero",
  stroke: "#333",
  strokeWidth: 0.5
});

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFilter;